<template>
  <div class="calendar">
    <div class="calendar__header">
      <div class="calendar__prev" @click="setUserCalendarMonth('prev')">
        <svg width="22" height="16" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 7L6 2L11 7" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <div class="calendar__current">
        <div class="calendar__month">{{ userCalendar.monthName }}</div>
        <div class="calendar__year">{{ userCalendar.year }}</div>
      </div>
      <div class="calendar__next" @click="setUserCalendarMonth('next')">
        <svg width="22" height="16" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 7L6 2L11 7" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
    </div>

    <div class="calendar__weekdays">
      <div class="calendar__weekdays-item"
           v-for="weekday in calendarWeekDays"
           :key="weekday"
      >
        {{ weekday }}
      </div>
    </div>
    <div class="calendar__days-wrap">
      <div v-for="day in userCalendar.days"
           :key="day.number"
           class="calendar__day"
           :class="{today: day.isToday, empty: day.isEmpty}"
           @click.stop="openEventModal(day.number)"
      >
            <span class="calendar__day-number">
              {{ day.number }}
            </span>
            <ul class="calendar__activity-list custom-scrollbar"
                v-if="day.activities && day.activities.length !== 0"
            >
              <li class="calendar__activity-item"
                  v-for="activity in day.activities"
                  :key="activity.id"
                  @click.stop="openActivityModal(activity)"
              >
                <span class="calendar__activity-marker" :style="`background: ${activity.color};`"></span>
                <span class="calendar__activity-name">{{ activity.name }}</span>
                <span class="calendar__activity-time">{{formatServerDateToTime(activity.start_at)}}</span>
              </li>
            </ul>
      </div>
    </div>

    <transition name="fade">
      <ActivityDetailModal v-if="detailModal.active"
                           :activity="detailModal.activity"
                           @close-modal="closeActivityModal"
                           @edit-event="editEvent"
      />

<!--      <UserEventModal v-if="eventModal.active"-->
<!--                      :state="eventModal"-->
<!--      />-->

      <EventModal v-if="eventModal.active" />
    </transition>

  </div>
</template>

<script>
/* eslint-disable */
import ActivityDetailModal from '@/components/page/modal/ActivityDetailModal'
import EventModal from '@/components/page/modal/EventModal'

export default {
  name: 'UserDetail_calendarTab',
  components: { EventModal, ActivityDetailModal },
  props: {},
  data () {
    return {}
  },
  computed: {
    userCalendar () {
      return this.$store.getters.getUserCalendarMonthCalendar
    },
    calendarWeekDays () {
      return this.$store.getters.getUserCalendarWeekDays
    },
    detailModal () {
      return this.$store.getters.getUserCalendarActivityModal
    },
    eventModal () {
      return this.$store.getters.getFeedEventModal
    }
  },
  methods: {
    setUserCalendarMonth (direction) {
      this.$store.dispatch('[user-calendar] setMonth', direction)
    },
    openActivityModal (activity) {
      this.$store.dispatch('[user-calendar] openActivityModal', { id: activity.id, ownerId: activity.itemable?.owner_id })
    },
    closeActivityModal () {
      this.$store.commit('[user-calendar] CLOSE_ACTIVITY_MODAL')
    },
    openEventModal (dayNumber) {
      const now = new Date()
      const date = new Date(this.userCalendar.year, this.userCalendar.month, dayNumber, now.getHours(), now.getMinutes())
      this.$store.dispatch('showFeedEventModal', date)
    },
    editEvent (data) {
      this.$store.commit('[user-calendar] CLOSE_ACTIVITY_MODAL')
      this.$store.dispatch('updateFeedPost', data)
    },
    formatServerDateToTime (time) {
      return time.split(' ').pop()
    }
  },
  mounted () {
    this.$store.dispatch('[user-calendar] initCalendar')
  },
  destroyed () {
    this.$store.commit('[user-calendar] CLOSE_ACTIVITY_MODAL')
  }
}

</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.calendar {
  margin-bottom: 20px;
  margin-right: 20px;
  background: $color_sixth;
  padding: 8px 10px 10px;

  &__header {
    display: flex;
    padding-bottom: 16px;
  }

  &__current {
    color: $color_second;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__month {
    font-weight: bold;
    font-size: 22px;
    text-transform: capitalize;
  }

  &__year {
    font-size: 20px;
  }

  &__prev,
  &__next {
    display: flex;
    align-items: center;
    color: $color_deactive;
    transition: .3s;
    cursor: pointer;
    user-select: none;
    flex-basis: 40px;

    @media screen and (min-width: $hover_enable_width) {
      &:hover {
        color: $color_second-light;
      }
    }
  }

  &__prev {
    justify-content: flex-start;

    svg {
      transform: rotate(-90deg)
    }
  }

  &__next {
    justify-content: flex-end;

    svg {
      transform: rotate(90deg)
    }
  }

  &__weekdays {
    display: flex;
    flex-flow: row nowrap;
    padding-bottom: 10px;

    &-item {
      display: flex;
      justify-content: center;
      align-items: center;
      color: $color_second;
      width: calc(100% / 7);

      &:nth-child(6),
      &:nth-child(7) {
        color: $color_error;
      }
    }
  }

  &__days-wrap {
    display: flex;
    flex-flow: row wrap;
  }

  &__day {
    position: relative;
    padding: 28px 6px 8px;
    margin-right: 2px;
    margin-bottom: 2px;
    width: calc((100% / 7) - 2px);
    height: 140px;
    background: $color_main;
    border: 1px solid $color_deactive;
    cursor: pointer;

    &-number {
      position: absolute;
      top: 4px;
      left: 8px;
      font-weight: bold;
      color: $color_deactive;
      user-select: none;
    }

    &:nth-child(6),
    &:nth-child(7),
    &:nth-child(13),
    &:nth-child(14),
    &:nth-child(20),
    &:nth-child(21),
    &:nth-child(27),
    &:nth-child(28),
    &:nth-child(34),
    &:nth-child(35),
    &:nth-child(41),
    &:nth-child(42) {
      border: 1px solid $color_error;

      .calendar__day-number {
        color: $color_error;
      }
    }

    &.today {
      background: $color_fourth;
      background: $color_fourth_gradient;
      color: $color_main;

      .calendar__day-number {
        color: $color_main;
      }
    }

    &.empty {
      background: $color_sixth;
      border: 1px solid $color_sixth;
    }
  }

  &__activity {
    &-list {
      height: 100%;
      overflow: auto;
      font-size: 12px;
      padding-right: 2px;
    }

    &-item {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      cursor: pointer;
      user-select: none;

      @media screen and (min-width: $hover_enable_width) {
        &:hover {
          color: $color_second-light;

          .calendar__activity-time {
            color: $color_second-light;
          }
        }
      }
    }

    &-marker {
      flex-shrink: 0;
      display: block;
      @include size(10px);
      border-radius: 50%;
      margin-right: 4px;
    }

    &-name {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 4px;
    }

    &-time {
      margin-left: auto;
      font-size: 12px;
    }
  }
}
</style>
